var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFirefox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.8925 33.5726C92.787 28.5057 88.5159 23.0349 85.1712 21.3055C87.5563 25.9247 89.2117 30.8853 90.0788 36.0111L90.0875 36.0923C84.6086 22.4372 75.3212 16.9227 67.7317 4.93066C67.3479 4.32418 66.964 3.71645 66.5902 3.07496C66.3764 2.70858 66.2051 2.37845 66.0563 2.07459C65.7416 1.46505 65.499 0.820873 65.3336 0.155118C65.3338 0.124397 65.3227 0.0946689 65.3024 0.0716054C65.2821 0.0485419 65.2541 0.0337571 65.2236 0.0300712C65.1937 0.0218773 65.1622 0.0218773 65.1323 0.0300712C65.1261 0.0300712 65.116 0.0413254 65.1085 0.0438264C65.101 0.0463273 65.0848 0.0575815 65.0735 0.0625834L65.0923 0.0300712C52.9204 7.15774 48.7881 20.3502 48.413 26.9527C43.5504 27.2861 38.9012 29.0775 35.072 32.0933C34.6727 31.755 34.2553 31.4386 33.8217 31.1455C32.7177 27.2802 32.6706 23.1895 33.6854 19.2998C29.2154 21.4654 25.2435 24.5354 22.0212 28.3157H21.9987C20.0782 25.881 20.2132 17.853 20.3232 16.1761C19.7551 16.4045 19.2127 16.6925 18.7053 17.0352C17.0099 18.2453 15.425 19.6032 13.9691 21.093C12.31 22.7752 10.7947 24.5935 9.43916 26.5288V26.5363V26.5275C6.32403 30.9437 4.11428 35.9332 2.93748 41.208L2.87247 41.5281C2.78119 41.9545 2.45236 44.0903 2.39609 44.5543C2.39609 44.5905 2.38859 44.6243 2.38484 44.6606C1.96067 46.8656 1.69782 49.0986 1.59839 51.3418V51.5919C1.6198 63.7196 6.18656 75.3987 14.3971 84.3235C22.6077 93.2483 33.8655 98.7704 45.9481 99.7996C58.0306 100.829 70.06 97.2904 79.6615 89.8829C89.263 82.4753 95.7389 71.7369 97.8108 59.7875C97.892 59.1622 97.9583 58.5433 98.0308 57.9118C99.0289 49.6611 97.9484 41.2917 94.8875 33.5651L94.8925 33.5726ZM39.0406 71.5119C39.2669 71.6207 39.4794 71.7382 39.712 71.842L39.7457 71.8633C39.5107 71.7507 39.2756 71.6336 39.0406 71.5119ZM90.0888 36.1061V36.0598L90.0975 36.1111L90.0888 36.1061Z",
    fill: "url(#paint0_linear_4902_29100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8925 33.5728C92.787 28.5059 88.5159 23.0351 85.1712 21.3057C87.5563 25.9248 89.2117 30.8854 90.0788 36.0112V36.0574L90.0875 36.1087C93.8232 46.799 93.283 58.5197 88.5796 68.821C83.0257 80.7392 69.5872 92.955 48.5443 92.3548C25.8134 91.7108 5.78323 74.8357 2.04476 52.74C1.36334 49.2549 2.04476 47.488 2.38735 44.6557C1.92004 46.8557 1.65926 49.0946 1.6084 51.3432V51.5933C1.62981 63.721 6.19657 75.4 14.4072 84.3249C22.6177 93.2497 33.8755 98.7718 45.9581 99.801C58.0407 100.83 70.07 97.2918 79.6715 89.8842C89.273 82.4767 95.7489 71.7383 97.8208 59.7888C97.902 59.1636 97.9683 58.5446 98.0408 57.9131C99.039 49.6624 97.9584 41.2931 94.8975 33.5665L94.8925 33.5728Z",
    fill: "url(#paint1_radial_4902_29100)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8925 33.5728C92.787 28.5059 88.5159 23.0351 85.1712 21.3057C87.5563 25.9248 89.2117 30.8854 90.0788 36.0112V36.0574L90.0875 36.1087C93.8232 46.799 93.283 58.5197 88.5796 68.821C83.0257 80.7392 69.5872 92.955 48.5443 92.3548C25.8134 91.7108 5.78323 74.8357 2.04476 52.74C1.36334 49.2549 2.04476 47.488 2.38735 44.6557C1.92004 46.8557 1.65926 49.0946 1.6084 51.3432V51.5933C1.62981 63.721 6.19657 75.4 14.4072 84.3249C22.6177 93.2497 33.8755 98.7718 45.9581 99.801C58.0407 100.83 70.07 97.2918 79.6715 89.8842C89.273 82.4767 95.7489 71.7383 97.8208 59.7888C97.902 59.1636 97.9683 58.5446 98.0408 57.9131C99.039 49.6624 97.9584 41.2931 94.8975 33.5665L94.8925 33.5728Z",
    fill: "url(#paint2_radial_4902_29100)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3365 39.2622C71.4415 39.336 71.5391 39.4097 71.6378 39.4835C70.4206 37.3248 68.9053 35.3484 67.1367 33.6126C52.0703 18.5444 63.1894 0.950309 65.0636 0.0499713L65.0824 0.0224609C52.9105 7.15013 48.7782 20.3426 48.4031 26.9451C48.9682 26.9063 49.5284 26.8588 50.106 26.8588C54.4244 26.8671 58.6636 28.0189 62.3927 30.1971C66.1217 32.3752 69.2075 35.5021 71.3365 39.2597V39.2622Z",
    fill: "url(#paint3_radial_4902_29100)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.131 42.276C50.051 43.4814 45.7924 47.6392 44.3033 47.6392C30.5247 47.6392 28.2866 55.9761 28.2866 55.9761C28.8968 62.9962 33.788 68.7809 39.7008 71.8321C39.9709 71.9721 40.2447 72.0984 40.5185 72.2222C40.9928 72.4323 41.4671 72.6265 41.9414 72.8049C43.9707 73.5231 46.096 73.9332 48.2468 74.0216C72.403 75.1546 77.0792 45.1358 59.6485 36.42C63.7602 35.885 67.9241 36.8961 71.3327 39.2573C69.2038 35.4997 66.1179 32.3729 62.3889 30.1948C58.6599 28.0166 54.4207 26.8648 50.1023 26.8564C49.5271 26.8564 48.9645 26.904 48.3993 26.9427C43.5368 27.2761 38.8876 29.0676 35.0584 32.0834C35.7973 32.7086 36.6313 33.544 38.388 35.2759C41.6763 38.5158 50.1098 41.8721 50.1285 42.266L50.131 42.276Z",
    fill: "url(#paint4_radial_4902_29100)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.131 42.276C50.051 43.4814 45.7924 47.6392 44.3033 47.6392C30.5247 47.6392 28.2866 55.9761 28.2866 55.9761C28.8968 62.9962 33.788 68.7809 39.7008 71.8321C39.9709 71.9721 40.2447 72.0984 40.5185 72.2222C40.9928 72.4323 41.4671 72.6265 41.9414 72.8049C43.9707 73.5231 46.096 73.9332 48.2468 74.0216C72.403 75.1546 77.0792 45.1358 59.6485 36.42C63.7602 35.885 67.9241 36.8961 71.3327 39.2573C69.2038 35.4997 66.1179 32.3729 62.3889 30.1948C58.6599 28.0166 54.4207 26.8648 50.1023 26.8564C49.5271 26.8564 48.9645 26.904 48.3993 26.9427C43.5368 27.2761 38.8876 29.0676 35.0584 32.0834C35.7973 32.7086 36.6313 33.544 38.388 35.2759C41.6763 38.5158 50.1098 41.8721 50.1285 42.266L50.131 42.276Z",
    fill: "url(#paint5_radial_4902_29100)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8015 30.4839C33.1941 30.734 33.5179 30.9516 33.8018 31.1479C32.6977 27.2826 32.6507 23.1919 33.6655 19.3022C29.1954 21.4678 25.2235 24.5379 22.0012 28.3181C22.2375 28.3119 29.2668 28.1856 32.8015 30.4839Z",
    fill: "url(#paint6_radial_4902_29100)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03607 52.7423C5.77579 74.8381 25.8047 91.7194 48.5356 92.3571C69.5785 92.9524 83.0195 80.7353 88.5709 68.8233C93.2743 58.5221 93.8145 46.8014 90.0788 36.111V36.0648C90.0788 36.0285 90.0713 36.0073 90.0788 36.0185L90.0876 36.0998C91.8068 47.3252 86.0978 58.1956 77.1717 65.5608L77.1442 65.6234C59.7522 79.7912 43.1104 74.1691 39.7471 71.8757C39.512 71.7632 39.2769 71.646 39.0419 71.5243C28.903 66.6775 24.7132 57.444 25.6134 49.5161C23.2067 49.5516 20.8413 48.8883 18.8038 47.6066C16.7664 46.3248 15.1443 44.4797 14.1342 42.2946C16.7959 40.6639 19.8307 39.7421 22.9496 39.6169C26.0685 39.4917 29.1675 40.1673 31.9513 41.5793C37.6894 44.1842 44.2187 44.4409 50.1435 42.2946C50.1247 41.9007 41.6913 38.5432 38.403 35.3045C36.6463 33.5726 35.8123 32.7385 35.0734 32.112C34.674 31.7737 34.2566 31.4573 33.823 31.1642C33.5355 30.9679 33.2116 30.7553 32.8228 30.5002C29.2881 28.2018 22.2588 28.3281 22.0262 28.3344H22.0037C20.0832 25.8997 20.2183 17.8717 20.3283 16.1948C19.7601 16.4232 19.2178 16.7112 18.7104 17.0539C17.015 18.264 15.43 19.6219 13.9742 21.1117C12.3091 22.7892 10.7876 24.6033 9.42548 26.535V26.5425V26.5337C6.31034 30.9499 4.1006 35.9394 2.9238 41.2142C2.90004 41.313 1.17835 48.8408 2.02732 52.7448L2.03607 52.7423Z",
    fill: "url(#paint7_radial_4902_29100)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1354 33.61C68.9045 35.3478 70.4198 37.3263 71.6366 39.4872C71.9029 39.6885 72.1517 39.8886 72.363 40.0824C83.3496 50.2112 77.5931 64.5291 77.1643 65.542C86.0891 58.188 91.7931 47.3101 90.0801 36.0809C84.5987 22.4133 75.3013 16.8987 67.7243 4.90673C67.3405 4.30026 66.9566 3.69253 66.5828 3.05104C66.369 2.68465 66.1977 2.35453 66.0489 2.05066C65.7342 1.44113 65.4917 0.796948 65.3262 0.131192C65.3264 0.100471 65.3154 0.0707431 65.2951 0.0476796C65.2748 0.0246162 65.2467 0.00983128 65.2162 0.00614543C65.1863 -0.00204848 65.1548 -0.00204848 65.1249 0.00614543C65.1187 0.00614543 65.1087 0.0173997 65.1012 0.0199006C65.0937 0.0224015 65.0774 0.0336557 65.0662 0.0386576C63.1919 0.927741 52.0753 18.5331 67.1417 33.5887L67.1354 33.61Z",
    fill: "url(#paint8_radial_4902_29100)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3618 40.0877C72.1505 39.8939 71.9017 39.6938 71.6354 39.4925C71.5366 39.4187 71.4391 39.3449 71.3341 39.2712C67.9255 36.9099 63.7615 35.8988 59.6498 36.4338C77.0793 45.1496 72.4031 75.1609 48.2481 74.0354C46.0974 73.947 43.972 73.5369 41.9427 72.8187C41.4684 72.6412 40.9941 72.4469 40.5199 72.236C40.246 72.111 39.9722 71.9859 39.7021 71.8459L39.7359 71.8671C43.1043 74.1667 59.7411 79.7851 77.1331 65.6148L77.1606 65.5523C77.5944 64.5394 83.3509 50.2215 72.3593 40.0927L72.3618 40.0877Z",
    fill: "url(#paint9_radial_4902_29100)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.288 55.9683C28.288 55.9683 30.5248 47.6314 44.3046 47.6314C45.7937 47.6314 50.0561 43.4736 50.1323 42.2681C44.2075 44.4145 37.6782 44.1578 31.9401 41.5529C29.1563 40.1408 26.0574 39.4652 22.9385 39.5904C19.8196 39.7156 16.7847 40.6375 14.123 42.2681C15.1332 44.4532 16.7552 46.2984 18.7927 47.5801C20.8301 48.8618 23.1955 49.5251 25.6023 49.4896C24.7045 57.4138 28.8931 66.646 39.0307 71.4979C39.257 71.6066 39.4696 71.7242 39.7022 71.828C33.7844 68.7706 28.8981 62.9884 28.288 55.972V55.9683Z",
    fill: "url(#paint10_radial_4902_29100)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8927 33.5726C92.7871 28.5057 88.516 23.0349 85.1714 21.3055C87.5564 25.9247 89.2119 30.8853 90.0789 36.0111L90.0877 36.0923C84.6088 22.4372 75.3214 16.9227 67.7319 4.93066C67.3481 4.32418 66.9642 3.71645 66.5904 3.07496C66.3766 2.70858 66.2053 2.37845 66.0565 2.07459C65.7418 1.46505 65.4992 0.820873 65.3338 0.155118C65.334 0.124397 65.3229 0.0946689 65.3026 0.0716054C65.2823 0.0485419 65.2543 0.0337571 65.2238 0.0300712C65.1939 0.0218773 65.1624 0.0218773 65.1325 0.0300712C65.1262 0.0300712 65.1162 0.0413254 65.1087 0.0438264C65.1012 0.0463273 65.085 0.0575815 65.0737 0.0625834L65.0925 0.0300712C52.9206 7.15774 48.7883 20.3502 48.4132 26.9527C48.9783 26.9139 49.5385 26.8664 50.1161 26.8664C54.4345 26.8747 58.6737 28.0265 62.4028 30.2047C66.1318 32.3828 69.2176 35.5097 71.3466 39.2673C67.938 36.906 63.7741 35.8949 59.6623 36.43C77.0918 45.1457 72.4156 75.157 48.2606 74.0316C46.1099 73.9431 43.9845 73.533 41.9552 72.8149C41.481 72.6373 41.0067 72.4431 40.5324 72.2321C40.2586 72.1071 39.9847 71.982 39.7147 71.842L39.7484 71.8633C39.5134 71.7507 39.2783 71.6336 39.0432 71.5119C39.2696 71.6207 39.4821 71.7382 39.7147 71.842C33.7969 68.7833 28.9106 63.0012 28.3005 55.986C28.3005 55.986 30.5373 47.6492 44.3171 47.6492C45.8062 47.6492 50.0686 43.4914 50.1449 42.2859C50.1261 41.892 41.6927 38.5345 38.4043 35.2958C36.6476 33.5639 35.8137 32.7298 35.0747 32.1033C34.6754 31.765 34.258 31.4486 33.8244 31.1555C32.7204 27.2902 32.6733 23.1995 33.6881 19.3098C29.218 21.4754 25.2461 24.5454 22.0239 28.3257H22.0013C20.0808 25.891 20.2159 17.863 20.3259 16.1861C19.7578 16.4145 19.2154 16.7025 18.708 17.0452C17.0126 18.2553 15.4277 19.6132 13.9718 21.103C12.3127 22.7852 10.7974 24.6035 9.44185 26.5388V26.5463V26.5375C6.32671 30.9537 4.11697 35.9432 2.94017 41.218L2.87515 41.5381C2.78388 41.9645 2.37502 44.1304 2.31626 44.5955C1.94229 46.8312 1.70346 49.0874 1.60107 51.3518V51.6019C1.62249 63.7296 6.18924 75.4087 14.3998 84.3335C22.6104 93.2583 33.8682 98.7804 45.9507 99.8096C58.0333 100.839 70.0627 97.3004 79.6642 89.8929C89.2657 82.4853 95.7416 71.7469 97.8134 59.7975C97.8947 59.1722 97.961 58.5533 98.0335 57.9218C99.0316 49.6711 97.9511 41.3017 94.8902 33.5751L94.8927 33.5726ZM90.0852 36.0623L90.0939 36.1136L90.0852 36.0623Z",
    fill: "url(#paint11_linear_4902_29100)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4902_29100",
    x1: 88.4783,
    y1: 15.5108,
    x2: 8.01976,
    y2: 93.1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.365 11.2769) scale(101.026 101.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8553 52.5424) scale(101.026 101.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3587 -11.2318) scale(73.1814 73.1899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6025 78.8022) scale(48.0999 48.1055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7417 43.8691) rotate(-13.5931) scale(25.5069 29.8653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6051 7.52533) scale(34.6089 34.613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.1122 -14.9831) scale(147.663 147.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8391 -6.79515) rotate(83.9767) scale(108.222 71.0171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6052 20.0302) scale(92.1738 92.1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4902_29100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.3613 25.0317) scale(100.889 100.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4902_29100",
    x1: 87.5033,
    y1: 15.0981,
    x2: 19.0526,
    y2: 83.5533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFirefox);
export default __webpack_public_path__ + "static/media/ic_firefox.2ea9b3e57e8143f4b255bbc294202877.svg";
export { ForwardRef as ReactComponent };